import {Collapse, Grid} from "@mui/material";
import {useState, useCallback, memo} from "react";
import MhdSelect from "../../atomicComponents/MhdSelect";
import {gridChoices} from "../../../utils/choices";
import MhdInput from "../../atomicComponents/MhdInput";
import WidgetSwitch from "../../atomicComponents/WidgetSwitch";
import WidgetDivider from "../../atomicComponents/WidgetDivider";
import MhdSwitch from "../../atomicComponents/MhdSwitch";
import MhdWidgetDivider from "../../atomicComponents/MhdWidgetDivider";
import {setAndUpdate, validateAndUpdate} from "../../../utils/helpers";

const ViewWidget = ({data, mods, warn, errs, update, setter, shared}) => {
  const [customXAxis, setCustomXAxis] = useState(false)
  const [customYAxis, setCustomYAxis] = useState(false)
  const [customVAxis, setCustomVAxis] = useState(false)
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <MhdSelect
          label="Grid"
          value={data.grid ? data.grid : 'null'}
          onChange={useCallback((v) => setAndUpdate("grid", v, setter, update), [])}
          choices={gridChoices}
        />
      </Grid>
      <Grid item xs={12}>
        <MhdWidgetDivider
            label="X AXIS"
            value={customXAxis}
            onChange={setCustomXAxis}
        >
          <Collapse in={customXAxis}>
            <Grid container spacing={1} pt={"2px"}>
              <Grid item xs={4}>
                <MhdInput
                  label='Ticks'
                  value={data.xaxis_ticks}
                  override={mods.xaxis_ticks}
                  warning={warn.xaxis_ticks}
                  error={errs.xaxis_ticks}
                  onChange={useCallback((v) => validateAndUpdate("xaxis_ticks", v, setter, update), [])}
                  units='°'
                />
              </Grid>
              <Grid item xs={4}>
                <MhdInput
                  label='Min'
                  value={data.xaxis_min}
                  override={mods.xaxis_min}
                  warning={warn.xaxis_min}
                  error={errs.xaxis_min}
                  onChange={useCallback((v) => validateAndUpdate("xaxis_min", v, setter, update), [])}
                  units='°'
                />
              </Grid>
              <Grid item xs={4}>
                <MhdInput
                  label='Max'
                  value={data.xaxis_max}
                  override={mods.xaxis_max}
                  warning={warn.xaxis_max}
                  error={errs.xaxis_max}
                  onChange={useCallback((v) => validateAndUpdate("xaxis_max", v, setter, update), [])}
                  units='°'
                />
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>
      <Grid item xs={12}>
        <MhdWidgetDivider
            label="Y AXIS"
            value={customYAxis}
            onChange={setCustomYAxis}
        >
          <Collapse in={customYAxis}>
            <Grid container spacing={1} pt={"2px"}>
              <Grid item xs={4}>
                <MhdInput
                  label="Ticks"
                  value={data.yaxis_ticks}
                  override={mods.yaxis_ticks}
                  warning={warn.yaxis_ticks}
                  error={errs.yaxis_ticks}
                  onChange={useCallback((v) => validateAndUpdate("yaxis_ticks", v, setter, update), [])}
                  units={'°'}
                />
              </Grid>
              <Grid item xs={4}>
                <MhdInput
                  label="Min"
                  value={data.yaxis_min}
                  override={mods.yaxis_min}
                  warning={warn.yaxis_min}
                  error={errs.yaxis_min}
                  onChange={useCallback((v) => validateAndUpdate("yaxis_min", v, setter, update), [])}
                  units={'°'}
                />
              </Grid>
              <Grid item xs={4}>
                <MhdInput
                  label="Max"
                  value={data.yaxis_max}
                  override={mods.yaxis_max}
                  warning={warn.yaxis_max}
                  error={errs.yaxis_max}
                  onChange={useCallback((v) => validateAndUpdate("yaxis_max", v, setter, update), [])}
                  units={'°'}
                />
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>

      <Grid item xs={12} mb={shared?.sim_widget?.data_product !== 'chmap' ? 0 : -1}>
        <Collapse in={shared?.sim_widget?.data_product !== 'chmap'}>
          <WidgetDivider
              label="COLORBAR"
              value={customVAxis}
              onChange={setCustomVAxis}
          >
            <Collapse in={customVAxis}>
              <Grid container spacing={1} pt={'2px'}>
                <Grid item xs={4}>
                  <MhdInput
                    label="Ticks"
                    value={data.zaxis_ticks}
                    override={mods.zaxis_ticks}
                    warning={warn.zaxis_ticks}
                    error={errs.zaxis_ticks}
                    onChange={useCallback((v) => validateAndUpdate("zaxis_ticks", v, setter, update), [])}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Collapse in={!data.symmetric}>
                    <MhdInput
                      label="Min"
                      value={data.zaxis_min}
                      override={mods.zaxis_min}
                      warning={warn.zaxis_min}
                      error={errs.zaxis_min}
                      onChange={useCallback((v) => validateAndUpdate("zaxis_min", v, setter, update), [])}
                    />
                  </Collapse>
                </Grid>
                <Grid item xs={4}>
                  <Collapse in={!data.symmetric}>
                    <MhdInput
                      label="Max"
                      value={data.zaxis_max}
                      override={mods.zaxis_max}
                      warning={warn.zaxis_max}
                      error={errs.zaxis_max}
                      onChange={useCallback((v) => validateAndUpdate("zaxis_max", v, setter, update), [])}
                    />
                  </Collapse>
                </Grid>
                <Grid item xs={4}>
                  <MhdSwitch
                    label="Symmetric"
                    value={data.symmetric}
                    override={mods.symmetric}
                    warning={warn.symmetric}
                    error={errs.symmetric}
                    onChange={useCallback((v) => setAndUpdate("symmetric", v, setter, update), [])}
                  />
                </Grid>
                <Grid item xs={8}>
                  <Collapse in={mods.symmetric !== undefined ? mods.symmetric : data.symmetric}>
                    <MhdInput
                      label="Value"
                      value={data.symmetric_value}
                      override={mods.symmetric_value}
                      warning={warn.symmetric_value}
                      error={errs.symmetric_value}
                      onChange={useCallback((v) => validateAndUpdate("symmetric_value", v, setter, update), [])}
                    />
                  </Collapse>
                </Grid>
              </Grid>
            </Collapse>
          </WidgetDivider>
        </Collapse>
      </Grid>
    </Grid>
  );
}

export default memo(ViewWidget);